import { Component } from 'react';
import Inline from '../Inline';
import CollapsibleBox from './CollapsibleBox';
import { Form } from 'devextreme-react';
import { style as styl } from 'typestyle';
import Theme from '../theme/Theme';

export const cardStyle = {
    display: 'flex', padding: '0.25rem 1rem', borderRadius: '1rem',
    margin: '0 0.25rem',
    alignItems: 'center', justifyContent: 'center', textAlign: 'center', cursor: 'pointer',
};

class Card extends Component {
    state = {
        width: this.props.width ?? '40vw',
    }

    static renderCardsO = ({ prefix, items, displayExpr, onItemClick, style, className, containerStyle }) => {
        if (!(items?.length > 0))
            return (prefix?.length > 0 && <span>{prefix}</span>);

        displayExpr ??= x => x.text ?? x;

        return (
            <Inline spacing={false} style={{ margin: '0 1rem', fontSize: '0.9rem', ...containerStyle }}>
                {prefix?.length > 0 && <span>{prefix}</span>}
                {
                    items.map((i, index) => (
                        <div style={{ ...cardStyle, background: Theme.col4('#ddd'), ...style, ...i.style }}
                            className={className}
                            key={`${displayExpr(i)}_${index}`}
                            onClick={() => {
                                i.onClick?.(index);
                                onItemClick?.(i, index)
                            }}
                            cursor={i.onClick || onItemClick ? 'pointer' : undefined}
                        >
                            {displayExpr(i)}
                        </div>
                    ))
                }
            </Inline>
        );
    }

    static renderCards = (prefix, items, displayExpr, onItemClick, style, className, containerStyle) => Card.renderCardsO({ prefix, items, displayExpr, onItemClick, style, className, containerStyle });

    renderCollapsibleForm = (title, summary, items) => {
        return (
            <CollapsibleBox width={this.state.width} opened={this.props.collapsed !== true}
                key={title + (this.props.key ?? '') + '_' + this.props.collapsed}
                className='loadorder-collapsibleboxd'
                style={{ width: this.state.width, margin: this.props.collapsed ? '2px auto' : '1rem auto' }}
                title={
                    <div className='loadorder-title'
                        style={{
                            height: '100%', display: 'flex', color: 'steelblue', justifyContent: 'center',
                            alignItems: 'center', fontWeight: '700',
                        }}
                    >
                        <span style={{ fontWeight: '900' }}>{title}</span>
                    </div>
                }
                headerStyle={{ width: `calc(${this.state.width} - 2rem)` }}
                summary={
                    <span className='loadorder-summary' style={{ margin: '0 1rem', fontSize: '0.8rem', color: '#550' }}>
                        {!Array.isArray(summary) ? summary : Card.renderCards('', summary)}
                    </span>
                }

                //farItems={[
                // <a href={apiPrefix + '/' + qr.answersUrl} download key='asdf'
                //     style={{ textDecoration: 'none' }}
                // >
                //     <MinimalButton text='دانلود پاسخ های داده شده' icon='download'
                //         style={{ fontWeight: '700', padding: '1rem' }}
                //     />
                // </a>
                //]}
                bodyStyle={{
                    ...this.props.formStyle, marginTop: '0',
                    borderRadius: /*this.props.collapsed ? '0' :*/ '0 0 1rem 1rem',
                    width: `calc(${this.state.width} - 2rem)`
                }}
            >
                <Form rtlEnabled colCount={60} width='100%' className='loadorder-form' // width='50vw'
                >
                    {items?.props?.children}
                </Form>
            </CollapsibleBox>
        );
    }

    render() {
        return (
            <div style={this.props.style}>
                {
                    (this.props.collapsibleForms ?? []).map(x => (
                        this.renderCollapsibleForm(x.title, x.summary, x.items)
                    ))}
            </div>
        );
    }
}

export default Card;
